import css from '@styled-system/css';
import { ThemeStyles } from '@honda-canada/design-system-react';

const themeStyles = new ThemeStyles();

themeStyles.addBaseStyles('SwatchesContent')(({ isDark }) =>
  css({
    fontFamily: 'bold',
    color: isDark ? 'white' : undefined,
    textAlign: ['center', 'left'],
  }),
);

themeStyles.addBaseStyles('ColorContent')(
  css({
    '& .fresnel-lessThan-desktop ul': {
      justifyContent: ['center', 'start'],
    },
    '& ul': {
      paddingTop: 0,
    },
    '& ul > li:first-child': {
      marginLeft: 0,
    },
    '& ul > li': {
      marginButtom: 0,
    },
  }),
);

themeStyles.addBaseStyles('Legal')(
  css({
    textAlign: 'center',
    fontSize: '12px',
    padding: '20px 0',
  }),
);

themeStyles.addBaseStyles('Content')(
  css({
    width: '100%',
    display: 'flex',
    paddingLeft: ['10px', '30px'],
    paddingRight: ['10px', '100px'],
    paddingBottom: 'xl',
    flexDirection: ['column', 'row'],
    gap: ['20px', '60px'],
  }),
);

themeStyles.addBaseStyles('CTA')(
  css({
    display: 'flex',
    flexDirection: ['column', 'row'],
    justifyContent: 'space-between',
    alignItems: ['center', 'start'],
    gap: '20px',
  }),
);

themeStyles.addBaseStyles('CTAButton')(
  css({
    width: 'max-content',
  }),
);

themeStyles.addBaseStyles('ToggleArea')(
  css({
    display: 'flex',
    gap: '20px',
  }),
);

themeStyles.addBaseStyles('ContentColumn')(
  css({
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
  }),
);

export default themeStyles;
